const serviceNameCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

const SERVICE_ARRAY_KEYS = new Set(["data", "serviceData", "servicesData"]);

const getSortableServiceName = (item) => item?.serviceName || item?.name || item?.rawName || "";

export const compareServiceNames = (left, right) =>
  serviceNameCollator.compare(getSortableServiceName(left), getSortableServiceName(right));

const isServiceReportItem = (item) => {
  if (!item || typeof item !== "object" || Array.isArray(item)) return false;
  if ("serviceName" in item || "serviceId" in item) return true;
  return (
    "name" in item &&
    (
      "agentsData" in item ||
      "arrivalTimes" in item ||
      "chart" in item ||
      "completed" in item ||
      "days" in item ||
      "max" in item ||
      "min" in item ||
      "total" in item ||
      "totalServiceData" in item ||
      "totalServiceTime" in item ||
      "waitingTimeInSeconds" in item
    )
  );
};

const shouldSortServiceArray = (items, key) =>
  SERVICE_ARRAY_KEYS.has(key) && items.some(isServiceReportItem);

const sortServiceArray = (items, key) =>
  shouldSortServiceArray(items, key) ? [...items].sort(compareServiceNames) : items;

export const sortServiceReportData = (node, key = null) => {
  if (Array.isArray(node)) {
    return sortServiceArray(
      node.map((item) => sortServiceReportData(item)),
      key
    );
  }

  if (!node || typeof node !== "object") {
    return node;
  }

  return Object.entries(node).reduce((nextNode, [childKey, value]) => {
    nextNode[childKey] = sortServiceReportData(value, childKey);
    return nextNode;
  }, {});
};
